import React from 'react'

const Avatar = ({ 
  src, 
  name, 
  size = 'md', 
  className = '',
  emoji = '👦'
}) => {
  const sizes = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-12 h-12 text-lg',
    lg: 'w-16 h-16 text-2xl',
    xl: 'w-20 h-20 text-3xl'
  }

  const getInitials = (name) => {
    return name?.split(' ').map(n => n[0]).join('').toUpperCase() || '?'
  }

  const baseClasses = `
    rounded-full flex items-center justify-center font-bold
    bg-gradient-to-br from-primary-400 to-secondary-400 text-white shadow-lg
    ${sizes[size]}
    ${className}
  `

  if (src) {
    return (
      <img 
        src={src} 
        alt={name} 
        className={`${baseClasses} object-cover`}
      />
    )
  }

  return (
    <div className={baseClasses}>
      {emoji || getInitials(name)}
    </div>
  )
}

export default Avatar